/**
 * Domain-specific contact configuration.
 * Each domain has its own set of WhatsApp contacts and visibility settings.
 */

import { isAlternateDomain } from '@/utils/domainUtils';

export interface ContactEntry {
  languageKey: string;           // translation key for ContactUs page
  connectLanguageKey: string;    // translation key for ConnectSection
  countryCode: string;           // emoji flag
  phoneNumber: string;
  visible: boolean;              // whether to show this contact
}

export interface DomainContactConfig {
  showEmail: boolean;
  emailAddress?: string;
  contacts: ContactEntry[];
}

const defaultContacts: DomainContactConfig = {
  showEmail: true,
  emailAddress: 'support@theclub.finance',
  contacts: [
    { languageKey: 'contactUs.languages.english', connectLanguageKey: 'connect.language.english', countryCode: '🇬🇧', phoneNumber: '+506 7178 8051', visible: true },
    { languageKey: 'contactUs.languages.italian', connectLanguageKey: 'connect.language.italian', countryCode: '🇮🇹', phoneNumber: '+39 338 148 4157', visible: true },
    { languageKey: 'contactUs.languages.spanish', connectLanguageKey: 'connect.language.spanish', countryCode: '🇪🇸', phoneNumber: '+506 7178 8051', visible: true },
    { languageKey: 'contactUs.languages.german', connectLanguageKey: 'connect.language.german', countryCode: '🇩🇪', phoneNumber: '+39 338 148 4157', visible: true },
    { languageKey: 'contactUs.languages.turkish', connectLanguageKey: 'connect.language.turkish', countryCode: '🇹🇷', phoneNumber: '+90 552 442 88 33', visible: true },
    { languageKey: 'contactUs.languages.french', connectLanguageKey: 'connect.language.french', countryCode: '🇫🇷', phoneNumber: '+506 7178 8051', visible: true },
    { languageKey: 'contactUs.languages.croatian', connectLanguageKey: 'connect.language.croatian', countryCode: '🇭🇷', phoneNumber: '+386 40 880 626', visible: false },
    { languageKey: 'contactUs.languages.arabic', connectLanguageKey: 'connect.language.arabic', countryCode: '🇦🇪', phoneNumber: '+39 340 261 7942', visible: false },
  ],
};

const alternateContacts: DomainContactConfig = {
  showEmail: false,
  contacts: [
    // TODO: Replace placeholder numbers with real alternate-domain contacts
    { languageKey: 'contactUs.languages.english', connectLanguageKey: 'connect.language.english', countryCode: '🇬🇧', phoneNumber: '+90 552 442 88 33', visible: true },
    { languageKey: 'contactUs.languages.italian', connectLanguageKey: 'connect.language.italian', countryCode: '🇮🇹', phoneNumber: '+90 552 442 88 33', visible: true },
    { languageKey: 'contactUs.languages.spanish', connectLanguageKey: 'connect.language.spanish', countryCode: '🇪🇸', phoneNumber: '+90 552 442 88 33', visible: true },
    { languageKey: 'contactUs.languages.german', connectLanguageKey: 'connect.language.german', countryCode: '🇩🇪', phoneNumber: '+90 552 442 88 33', visible: true },
    { languageKey: 'contactUs.languages.turkish', connectLanguageKey: 'connect.language.turkish', countryCode: '🇹🇷', phoneNumber: '+90 552 442 88 33', visible: true },
    { languageKey: 'contactUs.languages.french', connectLanguageKey: 'connect.language.french', countryCode: '🇫🇷', phoneNumber: '+90 552 442 88 33', visible: true },
    { languageKey: 'contactUs.languages.croatian', connectLanguageKey: 'connect.language.croatian', countryCode: '🇭🇷', phoneNumber: '+90 552 442 88 33', visible: false },
    { languageKey: 'contactUs.languages.arabic', connectLanguageKey: 'connect.language.arabic', countryCode: '🇦🇪', phoneNumber: '+90 552 442 88 33', visible: false },
  ],
};

export const getContactConfig = (): DomainContactConfig => {
  return isAlternateDomain() ? alternateContacts : defaultContacts;
};
